import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import groupBy from 'lodash.groupby';
import orderBy from 'lodash.orderby';
import uniqBy from 'lodash.uniqby';
import { ChatMessageItemFragment } from '@/components/Chat/ChatMessageItem.utils';
import type { ResultOf } from '@/gql/graphql';
import type { WatchMessageMediaStream } from '@/hooks/useGlobalSubscriptions';
import { setNextCursor } from '@/stores/useSubscriptionStreamStore';

export default function message_media_stream(
  ...vars: [
    parent: {
      message_media_stream: ResultOf<
        typeof WatchMessageMediaStream
      >['message_media_stream'];
    },
    args: any,
    cache: Cache,
    info: ResolveInfo,
  ]
) {
  const [parent, , cache] = vars;

  setNextCursor(
    'message_media',
    parent.message_media_stream[parent.message_media_stream.length - 1]
      .updated_at,
  );

  const remoteMediaItems = parent.message_media_stream.filter(
    (item) => item.media_id || item.url,
  );

  const messageMediaByMessageId = groupBy(remoteMediaItems, 'message_id');

  Object.keys(messageMediaByMessageId).forEach((messageId) => {
    const newMediaItems = messageMediaByMessageId[messageId];

    const fragment = cache.readFragment(ChatMessageItemFragment, {
      __typename: 'message',
      id: messageId,
    });

    if (fragment) {
      cache.writeFragment(ChatMessageItemFragment, {
        ...fragment,
        media: uniqBy(
          orderBy([...fragment.media, ...newMediaItems], ['order'], ['asc']),
          'id',
        ),
      });
    }
  });
}
